import React from 'react';
import { Field, reduxForm } from 'redux-form';

const ForgotPasswordStartForm = ({
  handleSubmit
}) => {
    return (
      <form
        onSubmit={handleSubmit}
        className="text-center"
      >
        <Field
          name="username"
          placeholder="Email address"
          label="username"
          type="text"
          component="input"
          className="form-control"
        />
        <button type="submit" className="btn green small-button">Get New Password</button>
      </form>
    );
}

export default reduxForm({
  form: 'forgot-password-start'
})(ForgotPasswordStartForm);
